"use strict";
import classNames from "classnames";
import Account from "../../api/account";
import Api from "../../api/api";
import DisablingButton from "../../components/disabling_button";
import ExceptionItem from "./exception_item";
import loadHelper from "../loads";
import NewException, { INVOICE_CONTEXT } from "./new_exception";
import ruleFormatter from "../../formatters/rules";
import CarrierService from "../../services/carrier_service";
import { isClickableException } from "../../helpers/exceptions_advance_pages";
import {
  CARRIER_INVOICE_MODEL_OBJECT_TYPE,
  FACTOR_INVOICE_MODEL_OBJECT_TYPE,
  LOAD_SHIPMENT_MODEL_OBJECT_TYPE
} from "../../api/exception_events";
import * as popout from "./../popout";
import UnapproveBanner from "./unapprove_banner";
import DOMPurify from "dompurify";
import { addIcon } from "../ui/icons";
import { Notification } from "../ui/v3/notification";
import { Button, ButtonSize, ButtonVariant } from "../ui/v3/button";
;
const RulesAndExceptions = React.createClass({
  propTypes: {
    carrierInvoice: React.PropTypes.object,
    factorInvoice: React.PropTypes.object,
    loadShipment: React.PropTypes.object,
    load: React.PropTypes.object,
    exceptionEvents: React.PropTypes.array,
    readOnly: React.PropTypes.bool,
    decorator: React.PropTypes.func,
    exceptionResolver: React.PropTypes.func,
    exceptionCreator: React.PropTypes.func,
    billingReqsPopout: React.PropTypes.object,
    v3ReskinEnabled: React.PropTypes.bool
  },
  getDefaultProps: function() {
    return {
      exceptionEvents: [],
      decorator: function() {
        return null;
      }
    };
  },
  getInitialState: function() {
    return { loading: [] };
  },
  isLoadShipmentApproved: function() {
    return this.modelObjectType() === LOAD_SHIPMENT_MODEL_OBJECT_TYPE && this.props.loadShipment.state === "Approved";
  },
  isLoadShipmentBilled: function() {
    return this.modelObjectType() === LOAD_SHIPMENT_MODEL_OBJECT_TYPE && this.props.loadShipment.billed_in_tms;
  },
  billedNotification: function() {
    if (this.isLoadShipmentBilled()) {
      return /* @__PURE__ */ React.createElement("div", { className: "load-detail__shipment-final-header" }, "No action needed. Status: ", this.props.loadShipment.shipment_status, ".");
    }
    if (this.isLoadShipmentApproved()) {
      return /* @__PURE__ */ React.createElement("div", { className: "load-detail__shipment-final-header" }, "No action needed. Status: Approved.");
    }
    return null;
  },
  render: function() {
    if (this.props.v3ReskinEnabled) {
      return this.renderV3Reskin();
    }
    const objectTypeName = `${this.modelObjectType()}-exception`;
    const hasNoExceptions = this.numExceptions() === 0;
    return /* @__PURE__ */ React.createElement("div", { className: `load-detail__rules ${objectTypeName}` }, /* @__PURE__ */ React.createElement("div", { className: "rules__header" }, this.exceptionHeader()), /* @__PURE__ */ React.createElement(UnapproveBanner, { carrierInvoice: this.props.carrierInvoice, loadShipment: this.props.loadShipment, load: this.props.load }), /* @__PURE__ */ React.createElement("div", { className: "rules__add-exception-container" }, this.newException()), this.billedNotification(), /* @__PURE__ */ React.createElement("ul", { className: "rules__list" }, hasNoExceptions ? this.emptyList() : [this.ruleList(), this.exceptionList()]));
  },
  renderV3Reskin: function() {
    const hasNoExceptions = this.numExceptions() === 0;
    return /* @__PURE__ */ React.createElement("div", { style: { display: "flex", flexDirection: "column", gap: "var(--space-xs)" } }, /* @__PURE__ */ React.createElement("div", { style: { display: "flex", gap: "var(--space-xxs)" } }, this.exceptionHeaderV3Reskin()), this.newException(), /* @__PURE__ */ React.createElement(
      UnapproveBanner,
      {
        carrierInvoice: this.props.carrierInvoice,
        loadShipment: this.props.loadShipment,
        load: this.props.load,
        v3ReskinEnabled: true
      }
    ), hasNoExceptions ? this.emptyList() : [this.ruleList(), this.exceptionList()]);
  },
  exceptionHeader: function() {
    if (this.modelObjectType() === LOAD_SHIPMENT_MODEL_OBJECT_TYPE) {
      const model = this.modelObject();
      if (model.customer_id != null && model.customer_name != null)
        return /* @__PURE__ */ React.createElement("span", null, /* @__PURE__ */ React.createElement("h3", { className: "rules__header--title" }, model.customer_name, " (", model.shipment_external_id, ") ", this.showAlert(), " ", this.addExceptionButton()), this.billingRequirementsLink());
      else
        return /* @__PURE__ */ React.createElement("span", null, /* @__PURE__ */ React.createElement("h3", { className: "rules__header--title" }, "Missing Customer ", this.showAlert(), " ", this.addExceptionButton()), this.billingRequirementsLink());
    } else if (Account.auditBillingEnabled()) {
      const maybeCarrier = CarrierService.carrierService.getCarrierOrUnknown(this.props.carrierInvoice.carrier_id);
      const carrier_name = maybeCarrier ? maybeCarrier.name : "Error " + Account.carrierTerm() + " not found";
      return /* @__PURE__ */ React.createElement("div", null, /* @__PURE__ */ React.createElement("div", { className: "indexer-header__subject" }, Account.carrierTerm(), " Exceptions"), /* @__PURE__ */ React.createElement("h3", { className: "rules__header--title" }, carrier_name, " ", this.showAlert(), " ", this.addExceptionButton()), this.billingRequirementsLink());
    } else
      return /* @__PURE__ */ React.createElement("span", null, /* @__PURE__ */ React.createElement("h3", { className: "rules__header--title" }, "Exceptions ", this.showAlert(), " ", this.addExceptionButton()), this.billingRequirementsLink());
  },
  exceptionHeaderV3Reskin: function() {
    const container = (els) => {
      return /* @__PURE__ */ React.createElement("div", { style: { display: "flex", gap: "var(--space-xxxs)" } }, els, this.showAlert(), this.addExceptionButton());
    };
    if (this.modelObjectType() === LOAD_SHIPMENT_MODEL_OBJECT_TYPE) {
      const model = this.modelObject();
      if (model.customer_id != null && model.customer_name != null) {
        return container(/* @__PURE__ */ React.createElement("span", null, model.customer_name, " (", model.shipment_external_id, ")"));
      } else {
        return container(/* @__PURE__ */ React.createElement("span", null, "Missing Customer"));
      }
    } else if (Account.auditBillingEnabled()) {
      const maybeCarrier = CarrierService.carrierService.getCarrierOrUnknown(this.props.carrierInvoice.carrier_id);
      const carrier_name = maybeCarrier ? maybeCarrier.name : "Error " + Account.carrierTerm() + " not found";
      return /* @__PURE__ */ React.createElement("div", null, /* @__PURE__ */ React.createElement("h4", null, Account.carrierTerm()), container(carrier_name));
    } else {
      return container(/* @__PURE__ */ React.createElement("h2", null, "Exceptions"));
    }
  },
  status: function() {
    const state = this.modelObject().state;
    if (this.modelObjectType() === LOAD_SHIPMENT_MODEL_OBJECT_TYPE && state && state.toLowerCase() == "exception") {
      const activeExceptionedItem = !!this.props.carrierInvoice && this.props.carrierInvoice.active_exceptioned_item;
      if (!!activeExceptionedItem && !!activeExceptionedItem.state && activeExceptionedItem.state.toLowerCase() != "unsent") {
        return activeExceptionedItem.state;
      } else {
        return "Exception";
      }
      ;
    } else {
      return this.modelObject().state;
    }
    ;
  },
  hasNoUnignoredExceptions: function() {
    return this.numExceptionsNotIgnored() === 0;
  },
  emptyList: function() {
    if (this.props.v3ReskinEnabled) {
      return /* @__PURE__ */ React.createElement(Notification, { message: "No exceptions" });
    } else {
      return /* @__PURE__ */ React.createElement("li", { className: "rules__all-pass" }, "No Exceptions");
    }
  },
  numExceptions: function() {
    return this.failureMessages().length + this.props.exceptionEvents.length;
  },
  numExceptionsNotIgnored: function() {
    const failures = this.failureMessages().filter((rule) => {
      return !loadHelper.ruleIsIgnored(this.modelObject(), rule);
    });
    return failures.length + this.props.exceptionEvents.length;
  },
  modelObject: function() {
    const objectLookup = {};
    objectLookup[LOAD_SHIPMENT_MODEL_OBJECT_TYPE] = this.props.loadShipment;
    objectLookup[CARRIER_INVOICE_MODEL_OBJECT_TYPE] = this.props.carrierInvoice;
    objectLookup[FACTOR_INVOICE_MODEL_OBJECT_TYPE] = this.props.factorInvoice;
    return objectLookup[this.modelObjectType()];
  },
  modelObjectType: function() {
    if (this.props.loadShipment) {
      return LOAD_SHIPMENT_MODEL_OBJECT_TYPE;
    } else if (this.props.carrierInvoice) {
      return CARRIER_INVOICE_MODEL_OBJECT_TYPE;
    } else {
      return FACTOR_INVOICE_MODEL_OBJECT_TYPE;
    }
  },
  failureMessages: function() {
    return this.modelObject() && this.modelObject().failure_messages || [];
  },
  ruleList: function() {
    return this.failureMessages().map(this.showRuleFailure);
  },
  showRuleFailure: function(rule) {
    const ignored = loadHelper.ruleIsIgnored(this.modelObject(), rule);
    const message = ruleFormatter.rule(rule);
    const sanitizedMessage = DOMPurify.sanitize(message, { USE_PROFILES: { html: true } });
    const load = this.props.load;
    const possibleLoadNoteContext = this.possibleLoadNoteContext({
      rule,
      load: load && load.load
    });
    const possibleAdditionalDetails = this.possibleAdditionalDetails({
      rule
    });
    if (this.props.v3ReskinEnabled) {
      const classes = classNames({
        "v3__type__body": true,
        "rules__ignored": ignored
      });
      return /* @__PURE__ */ React.createElement("div", { style: {
        display: "flex",
        gap: "24px",
        justifyContent: "space-between",
        alignItems: "flex-start",
        padding: "16px",
        border: "1px solid var(--color-border-default)",
        borderRadius: "8px"
      }, onClick: () => this.props.exceptionClicked(rule) }, /* @__PURE__ */ React.createElement("div", { style: {
        display: "flex",
        flexDirection: "column",
        alignSelf: "center"
      } }, /* @__PURE__ */ React.createElement("span", { className: classes, dangerouslySetInnerHTML: { __html: sanitizedMessage } }), possibleLoadNoteContext, possibleAdditionalDetails), this.ruleButtonV3Reskin(rule, ignored));
    } else {
      const decoration = this.props.decorator(rule, sanitizedMessage);
      const classes = classNames({
        "rules__ignored": ignored,
        "rules__item-text": true,
        "rules__clickable": isClickableException(rule)
      });
      return /* @__PURE__ */ React.createElement("li", { className: "rules__item", onClick: () => this.props.exceptionClicked(rule) }, /* @__PURE__ */ React.createElement("span", { className: classes }, /* @__PURE__ */ React.createElement("span", { className: "text" }, /* @__PURE__ */ React.createElement("span", { dangerouslySetInnerHTML: { __html: sanitizedMessage } }), " ", decoration, possibleLoadNoteContext, possibleAdditionalDetails)), this.ruleButton(rule, ignored));
    }
  },
  possibleAdditionalDetails({ rule }) {
    if (rule.display_text_details) {
      return rule.display_text_details.map((item, index) => this.additionalDetail(item.text));
    }
  },
  possibleLoadNoteContext({ rule, load }) {
    if (load && load.data && rule && rule.rule_type === "note_on_load") {
      switch (rule.failure_type) {
        case "load_note":
          return this.additionalDetail(load.data.load_note);
        case "payables_note":
          return this.additionalDetail(load.data.payables_note);
      }
    }
  },
  additionalDetail: function(note) {
    if (this.props.v3ReskinEnabled) {
      return /* @__PURE__ */ React.createElement("div", { className: "v3__type__small-body", style: { color: "var(--color-grayscale-600)" } }, note);
    } else {
      return /* @__PURE__ */ React.createElement("span", { className: "rules__additional_details" }, note);
    }
  },
  showAlert: function() {
    if (!this.hasNoUnignoredExceptions()) {
      if (this.props.v3ReskinEnabled) {
        const num = this.numExceptionsNotIgnored();
        const countClass = 0 <= num && num <= 9 ? "v3__badge-count--single-digit" : "";
        return /* @__PURE__ */ React.createElement("span", { className: "v3__badge v3__badge--alert v3__badge--size-default" }, /* @__PURE__ */ React.createElement("span", { className: `v3__badge-count ${countClass}` }, num));
      } else {
        return /* @__PURE__ */ React.createElement("span", { className: "round alert label rules__header__alert" }, this.numExceptionsNotIgnored());
      }
    }
  },
  ruleButton: function(rule, ignored) {
    if (rule.data.unskippable) {
      return /* @__PURE__ */ React.createElement(
        "button",
        {
          disabled: "true",
          className: "rules__ignore-button rules__ignore-button--disabled"
        },
        "Required"
      );
    }
    if (!this.props.readOnly) {
      if (ignored) {
        return /* @__PURE__ */ React.createElement(
          DisablingButton,
          {
            onClick: (event) => {
              event.preventDefault();
              event.stopPropagation();
              this.enableRule(rule);
            },
            disabled: this.isLoading(rule),
            disabledText: "Enabling...",
            disabledClassName: "rules__ignore-button rules__ignore-button--disabled",
            className: "rules__ignore-button"
          },
          "Enable"
        );
      }
      return /* @__PURE__ */ React.createElement(
        DisablingButton,
        {
          onClick: (event) => {
            event.preventDefault();
            event.stopPropagation();
            this.ignoreRule(rule);
          },
          disabled: this.isLoading(rule),
          disabledText: "Ignoring...",
          disabledClassName: "rules__ignore-button rules__ignore-button--disabled",
          className: "rules__ignore-button"
        },
        "Ignore"
      );
    }
  },
  ruleButtonV3Reskin: function(rule, ignored) {
    if (rule.data.unskippable) {
      return /* @__PURE__ */ React.createElement(
        Button,
        {
          size: ButtonSize.Medium,
          variant: ButtonVariant.Outlined,
          disabled: true
        },
        "Required"
      );
    }
    if (!this.props.readOnly) {
      const isLoading = this.isLoading(rule);
      if (ignored) {
        return /* @__PURE__ */ React.createElement(
          Button,
          {
            size: ButtonSize.Medium,
            onClick: (event) => {
              event.preventDefault();
              event.stopPropagation();
              this.enableRule(rule);
            },
            disabled: isLoading,
            variant: ButtonVariant.Outlined
          },
          isLoading ? "Enabling..." : "Enable"
        );
      }
      return /* @__PURE__ */ React.createElement(
        Button,
        {
          size: ButtonSize.Medium,
          onClick: (event) => {
            event.preventDefault();
            event.stopPropagation();
            this.ignoreRule(rule);
          },
          disabled: isLoading,
          variant: ButtonVariant.Outlined
        },
        isLoading ? "Ignoring..." : "Ignore"
      );
    }
  },
  isLoading: function(rule) {
    return this.state.loading.indexOf(rule) >= 0;
  },
  startLoading: function(rule) {
    this.setState({ loading: this.state.loading.concat([rule]) });
  },
  doneLoading: function(rule) {
    return () => {
      this.setState({ loading: _.without(this.state.loading, rule) });
    };
  },
  enableRule: function(rule) {
    this.startLoading(rule);
    const done = this.doneLoading(rule);
    Api.Rules.enable(this.modelObject().id, rule, this.modelObjectType()).then(done).catch(done);
  },
  ignoreRule: function(rule) {
    this.startLoading(rule);
    const done = this.doneLoading(rule);
    Api.Rules.ignore(this.modelObject().id, rule, this.modelObjectType()).then(done).catch(done);
  },
  exceptionList: function() {
    return this.props.exceptionEvents.map(this.showException);
  },
  newException: function() {
    if (this.state.adding) {
      return /* @__PURE__ */ React.createElement(
        NewException,
        {
          context: INVOICE_CONTEXT,
          customExceptionOnly: true,
          exceptionCreator: this.createException,
          onCancel: this.cancelNewException,
          modelObjectType: this.modelObjectType(),
          v3ReskinEnabled: this.props.v3ReskinEnabled
        }
      );
    }
  },
  createException: function(message, ignore, types) {
    return this.props.exceptionCreator(message, ignore, types).then(() => {
      this.setState({ adding: false });
    });
  },
  cancelNewException: function() {
    this.setState({ adding: false });
  },
  addExceptionButton: function() {
    if (this.isLoadShipmentApproved()) {
      return;
    }
    if (this.isLoadShipmentBilled()) {
      return;
    }
    if (this.state.adding) {
      return;
    }
    if (!this.props.exceptionCreator) {
      return;
    }
    if (this.props.readOnly) {
      return;
    }
    if (this.props.v3ReskinEnabled) {
      return /* @__PURE__ */ React.createElement(
        Button,
        {
          size: ButtonSize.Small,
          variant: ButtonVariant.Text,
          style: { padding: 0 },
          onClick: () => {
            this.setState({ adding: true });
          }
        },
        addIcon(),
        /* @__PURE__ */ React.createElement("span", null, "Add")
      );
    } else {
      return /* @__PURE__ */ React.createElement("a", { onClick: () => {
        this.setState({ adding: true });
      } }, /* @__PURE__ */ React.createElement("i", { className: "fi-plus" }));
    }
  },
  showException: function(exception) {
    return /* @__PURE__ */ React.createElement(
      ExceptionItem,
      {
        exception,
        exceptionResolver: this.props.exceptionResolver,
        owner: this.props.load,
        v3ReskinEnabled: this.props.v3ReskinEnabled
      }
    );
  },
  billingRequirementsLink: function() {
    const loadShipment = this.props.loadShipment;
    let customerId;
    let showAlertIcon;
    let isHidden;
    if (Account.auditBillingEnabled()) {
      if (loadShipment && this.modelObjectType() === LOAD_SHIPMENT_MODEL_OBJECT_TYPE) {
        customerId = loadShipment.customer_id;
        showAlertIcon = loadShipment.customer_instructions;
      } else {
        isHidden = true;
      }
    } else {
      const tmsLoadShipments = this.props.load && this.props.load.load && this.props.load.load.tms_load_shipments || [];
      showAlertIcon = tmsLoadShipments.some(
        (shipment) => shipment.customer_instructions
      );
    }
    if (this.useBillingReqsPopout() && !isHidden) {
      const tooltipText = "Customer instructions are present";
      return /* @__PURE__ */ React.createElement("div", { className: "rules__header--details" }, /* @__PURE__ */ React.createElement("a", { onClick: () => this.openBillingReqsPopout(customerId) }, showAlertIcon && /* @__PURE__ */ React.createElement("span", { className: "popup__wrapper" }, /* @__PURE__ */ React.createElement("span", { className: "popup" }, tooltipText), /* @__PURE__ */ React.createElement("span", { className: "icon-alert" })), "Customer Details"));
    }
  },
  openBillingReqsPopout(customerId) {
    popout.setCustomerId(customerId);
    popout.openOrFocusBillingReqsPopout();
  },
  useBillingReqsPopout() {
    return Account.useBillingReqsPopout() && Account.hasRole("Broker");
  }
});
export default RulesAndExceptions;
